import { Injectable, inject } from '@angular/core';
import { excludedWidgetsUrls } from '@models/widget.model';
import { AbilityService } from 'ability';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { PermissionsEnum } from 'mbs-ui-shared@models';
import { ShowChatEnum } from 'mbs-ui-shared@models/ProviderData';

@Injectable({ providedIn: 'root' })
export class ChatVisibilityService {
  private ability = inject(AbilityService);
  private auth = inject(AuthFacade);

  get chatChannel(): ShowChatEnum {
    return this.auth.currentUserValue?.ProviderInfo?.Chat ?? ShowChatEnum.Hide;
  }

  canShowChatByPermissions(): boolean {
    if (this.chatChannel === ShowChatEnum.Hide) return false;
    if (this.auth.currentUserValue?.IsProvider) return true;
    return this.ability.can('read', PermissionsEnum.EnableSupportChat);
  }

  canShowChatByUrl(url: string): boolean {
    return !excludedWidgetsUrls.some((excluded) => url.includes(excluded));
  }

  canShowChat(url: string): boolean {
    return this.canShowChatByPermissions() && this.canShowChatByUrl(url);
  }
}
